export function sourceKeyLabel(sourceKey: string): string {
    if (!sourceKey || sourceKey === 'other' || sourceKey === 'unscoped' || sourceKey.startsWith('src-')) {
        return 'Other';
    }
    const special: Record<string, string> = {
        github: 'GitHub',
        gmail: 'Gmail',
        linkedin: 'LinkedIn',
        powerschool: 'PowerSchool',
        seesaw: 'Seesaw',
    };
    if (special[sourceKey]) return special[sourceKey];
    return sourceKey
        .split(/[-_]+/)
        .filter(Boolean)
        .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
        .join(' ') || 'Other';
}
